import { ChangeDetectorRef, Component, inject, Input, PLATFORM_ID } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { DocumentSpecificSearchService } from '../../kb-CustomDocumentSearchTab/document-specific-search.service';
import { FileDownloadService } from '@spartacus/storefront';
import { isPlatformBrowser } from '@angular/common';
import { DocumnetWebtrekkTrackingService } from './documnetWebtrekkTrackingService';
import { saveAs } from 'file-saver';
import { Subject, take, takeUntil } from 'rxjs';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
@Component({
  selector: 'app-kb-document-grid',
  templateUrl: './kb-document-grid.component.html',
  styleUrls: ['./kb-document-grid.component.scss'],
  standalone: false
})
export class KbDocumentGridComponent {
  @Input('product') product: any;
  @Input() searchQuery: any;
  isLoggedIn: boolean = false;
  addfav: boolean;
  tooltip: boolean = false;
  platformId = inject(PLATFORM_ID);
  private destroy$ = new Subject<void>();
  private webtrekkTrackingService = inject(DocumnetWebtrekkTrackingService)
  constructor(private AuthService: AuthService,
    private service: DocumentSpecificSearchService,
    private fileDownloadService: FileDownloadService,
    private cdr: ChangeDetectorRef,
    private activeCartService: ActiveCartFacade,
  ) { }
  ngOnChanges() {
    if (this.product?.isFavorite) {
      this.addfav = true;
    }
    else {
      this.addfav = false;
    }
  }
  ngOnInit() {
    this.AuthService.isUserLoggedIn().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        this.isLoggedIn = data;
      }
      else {
        this.isLoggedIn = false;
      }
    })
  }

  isMobile(): boolean {
    return window.innerWidth < 768;
  }

  //tooltip = false;

  onHover(value: boolean) {
    if (!this.isMobile()) {
      this.tooltip = value;
    }
  }


  onMobileClick(event: Event, product: any) {
    if (this.isMobile()) {
      event.stopPropagation();

      // ✅ Directly trigger action instead of waiting second click
      this.SubscribeDoc(product);

      // Optional: toggle tooltip if you still want visual feedback
      this.tooltip = !this.tooltip;
    }
  }

  SubscribeDoc(data: any) {
    if (this.addfav) {
      this.unSubscribeDoc(data);
      this.addfav = false; // ✅ update UI immediately
      return;
    }

    this.service.getDownloadPopup().subscribe((response: any) => {
      const payLoad = {
        code: data.code,
        email: response.displayUid,
        name: response.name,
        revision: data.revision,
        language: data.isoCode
      };

      const apiCall = this.service.inPdp
        ? this.service.addToFavFromPdp(payLoad)
        : this.service.exceptPdpAddToFavFrom(payLoad);

      apiCall.subscribe(() => {
        this.addfav = true; // ✅ update UI immediately
        this.cdr.detectChanges(); // ✅ trigger change detection  
      });
    });
  }
  unSubscribeDoc(data: any) {
    if (this.service.inPdp) {
      this.service.removeFavFromPdp(data).pipe(takeUntil(this.destroy$)).subscribe();
    } else {
      this.service.removeFavDoc(data).pipe(takeUntil(this.destroy$)).subscribe();
    }

  }
  callApi(data: any) {
    this.trackDownload(data.url);
    if (data.url.includes('.pdf')) {
      const payLoadforpdf = {
        url: data.url,
        documentCode: data.code,
        documentLanguage: data.language,
        revision: data.revision,
      }
      this.service.getTimeStampInPdf(payLoadforpdf).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          const file = new Blob([res], { type: res.type });
          const url = URL.createObjectURL(file);
          if (isPlatformBrowser(this.platformId)) {
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            if (isIOS) {
              saveAs(file, `${data.code}.pdf`);
            }
            else {
              const link = document.createElement('a');
              link.href = url;
              link.target = "_blank";
              link.click();
            }
          }
        },
        error: () => {

        },
      });
    }
    else {
      if (isPlatformBrowser(this.platformId)) {
        const link = document.createElement('a');
        link.href = data.url;
        link.target = "_blank";
        link.click();
      }
    }
  }
  trackDownload(name: string): void {
    /* this.mapp.action({
      name: 'NA_Document_Download_' + name,
    });
    this.mapp.trackAction(true); */
    this.activeCartService.getActive().pipe(
      take(1)
    ).subscribe((item: any) => {
      this.webtrekkTrackingService.trackAction(name, item?.currentB2BUnit?.uid);
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
